export var MODAL_INIT = 'MODAL_INIT';
export var SET_MODAL = 'SET_MODAL';
export var HIDE_MODAL = 'HIDE_MODAL';
export var INIT_CLOSE_MODAL = 'INIT_CLOSE_MODAL';
export var CLOSE_MODAL = 'CLOSE_MODAL';
export var INIT_MODAL_CLOSING_WITH_ANSWER = 'INIT_MODAL_CLOSING_WITH_ANSWER';
export var CLOSING_MODAL_WITH_ANSWER = 'CLOSING_MODAL_WITH_ANSWER';